<template>
  <div>
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <app-cells>
        <app-input
          @input.native="onGroupsSearch"
          v-model="search"
          class="input--200"
          type="search"
          placeholder="Search by group name"
          name="search"
        />
      </app-cells>
      <div v-for="section of summitSections" :key="section.key" class="climbing-block">
        <app-cells>
          <h2 class="title">{{ section.label }}</h2>
          <div class="status-title" :style="{ backgroundColor: section.color }">
            {{ section.date }}
          </div>
        </app-cells>
        <v-client-table
          :data="section.items"
          :columns="table.columns"
          :options="table.options"
          class="table-default"
          :class="{ 'table-default--loading': table_preloader }"
          @row-click="openGroupPreview"
        >
          <template #h__name><div class="table-default__left">Name</div></template>
          <template #h__type><div class="table-default__left">Type</div></template>
          <template #h__route.name><div class="table-default__left">Route</div></template>
          <template #h__camp><div class="table-default__left">Camp</div></template>
          <template #h__chief_guide><div class="table-default__left">Guide</div></template>
          <template #name="{ row }">
            <div class="table-default__left table-default__controls">
              <a
                :href="`${row.gps?.shared_link}`"
                target="_blank"
                class="table-default__activity table-default__activity--gps"
                :class="{'table-default__activity--active': row.gps}"
              />
              <router-link
                :to="{ name: 'climbing-groups-detail-clients', params: { id: row.id } }"
                class="table-default__link-border table-default__link-border--inline"
              >
                {{ row.name }}
              </router-link> ({{ row.pax }})
            </div>
          </template>
          <template #type="{ row }">
            <div class="table-default__left">
              <span class="status-tag" :style="{ backgroundColor: row.type?.color || '#8a8a8a' }">
                {{ row.type ? row.type.name : '-' }}
              </span>
            </div>
          </template>
          <template #route.name="{ row }">
            <div class="table-default__left">{{ row.route.name }} {{ row.route.duration }}</div>
          </template>
          <template #camp="{ row }">
            <div class="table-default__left">{{ row.camp ? row.camp.name : '-' }}</div>
          </template>
          <template #chief_guide="{ row }">
            <div class="table-default__left">
              {{ row.chief_guide ? row.chief_guide.full_name : '-' }}
            </div>
          </template>
        </v-client-table>
      </div>
      <app-cells position="between">
        <div>
          <paginate
            :clickHandler="onClickPagination"
            v-if="pagination.pages > 1"
            v-model="pagination.page"
            :page-count="pagination.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination.count" :count="tableLength" :page="pagination.page" :limit="40" />
      </app-cells>
    </template>
  </div>
</template>

<script>
import { getClimbingSummitGroups } from '@/http'
import debounce from 'lodash/debounce'
import { addDays, format } from 'date-fns'
import previewRow from './previewRow'

export default {
  name: 'ClimbingGroupsSummitList',
  mixins: [previewRow],
  data() {
    return {
      is_loaded: false,
      table_preloader: false,
      search: null,
      climbing_table: [],
      table: {
        columns: ['name', 'type', 'route.name', 'camp', 'chief_guide'],
        options: {
          headings: {
            'name': 'Name',
            'type': 'Type',
            'route.name': 'Route',
            'camp': 'Camp',
            'chief_guide': 'Guide',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 40,
          texts: { noResults: 'No groups' },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false,
        },
      },
      pagination: { pages: 1, page: 1, count: 0 },
    }
  },
  computed: {
    summitSections() {
      const today = new Date()
      return [
        { key: 'today', label: 'Today', value: today, color: '#77b017' },
        { key: 'tomorrow', label: 'Tomorrow', value: addDays(today, 1), color: '#8a8a8a' },
      ].map(section => {
        const name = format(section.value, 'dd MMM yyyy')
        const source = this.climbing_table.find(item => item.name === name)
        return {
          ...section,
          date: format(section.value, 'dd MMM'),
          items: source ? source.items : [],
        }
      })
    },
    tableLength() {
      return this.summitSections.reduce((total, section) => total + section.items.length, 0)
    },
  },
  created() {
    this.fetchItems()
  },
  methods: {
    onClickPagination(page) {
      this.table_preloader = true
      this.pagination.page = page
      this.fetchItems()
    },
    fetchItems() {
      getClimbingSummitGroups({
        page: this.pagination.page,
        page_size: 40,
        search: this.search,
      }).then(res => {
        this.climbing_table = res.data.results
        this.pagination.pages = res.data.pages
        this.pagination.count = res.data.count
        this.is_loaded = true
        this.table_preloader = false
      })
    },
    onGroupsSearch() {
      this.table_preloader = true
      this.searchGroups(this)
    },
    searchGroups: debounce(vm => {
      vm.pagination.page = 1
      vm.fetchItems()
    }, 350),
  },
}
</script>

<style lang="sass" scoped>
.climbing-block
  margin-bottom: 30px
</style>
